// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__25P4V","detailsBorder":"styles_detailsBorder__2GNCp"};